// FavoritesScreen.tsx
import React from "react";
import { MdFavoriteBorder } from "react-icons/md";
import { useTheme } from "../../common/hooks/useTheme";
import { MobileHeader } from "../../common/components/mobileHeader/MobileHeader";
import { ProductHeader } from "../../common/components/productHeader/ProductHeader";
import { EmptyState } from "../../common/components/emptyState/EmptyState";
import Search from "../../common/components/search/Search";
import ItemList from "../main/components/itemList/ItemList";
import styles from "./FavoritesScreen.module.scss";
import { useFavoritesScreen } from "./useFavoritesScreen";
import { PageMeta } from "../../common/components/pageMeta/PageMeta";

export default function FavoritesScreen() {
  const { theme } = useTheme();
  const {
    favorites,
    getCategoryName,
    isAuth,
    usingStock,
    handleGroupPress,
    searchQuery,
    handleSearchChange,
    handleSearchClear,
  } = useFavoritesScreen();

  const subtitle =
    favorites.length > 0 ? `${favorites.length} тов.` : undefined;

  if (favorites.length === 0 && !searchQuery) {
    return (
      <div
        className={styles.container}
        style={{ backgroundColor: theme.background }}
      >
        <PageMeta />
        <div className={styles.mobileOnly}>
          <MobileHeader title="Избранное" />
        </div>
        <div className={styles.desktopOnly}>
          <ProductHeader
            title="Избранное"
            isFavorite={false}
            showFavorite={false}
            textColor={theme.text}
            borderColor={theme.border}
          />
        </div>
        <EmptyState
          icon={MdFavoriteBorder}
          title="Избранное пусто"
          description="Добавляйте товары в избранное, чтобы вернуться к ним позже"
        />
      </div>
    );
  }

  return (
    <div
      className={styles.container}
      style={{ backgroundColor: theme.background }}
    >
      <PageMeta />
      <div className={styles.mobileOnly}>
        <MobileHeader title="Избранное" subtitle={subtitle} />
      </div>
      <div className={styles.desktopOnly}>
        <ProductHeader
          title={`Избранное (${favorites.length})`}
          isFavorite={false}
          showFavorite={false}
          textColor={theme.text}
          borderColor={theme.border}
        />
      </div>
      <div className={styles.content}>
        <div className={styles.searchWrapper}>
          <Search
            value={searchQuery}
            onChange={handleSearchChange}
            clear={handleSearchClear}
            placeHolder="Поиск по избранному"
          />
        </div>
        {favorites.length === 0 ? (
          <EmptyState
            icon={MdFavoriteBorder}
            title={searchQuery ? "Ничего не найдено" : "Избранное пусто"}
            description={
              searchQuery
                ? "Попробуйте изменить поисковый запрос"
                : "Добавляйте товары в избранное, чтобы вернуться к ним позже"
            }
          />
        ) : (
          <ItemList
            items={favorites}
            getCategoryName={getCategoryName}
            isAuth={isAuth}
            usingStock={usingStock}
            onGroupPress={handleGroupPress}
          />
        )}
      </div>
    </div>
  );
}
